import { AxiosResponse } from "axios";
import agent from "./agent";

export interface ApiKeyCreator {
  id: string;
  firstName: string | null;
  lastName: string | null;
  email: string;
}

export interface AdminApiKey {
  id: string;
  label: string;
  maskedKey: string;
  scopes: string[];
  rateLimitTier: string;
  lastUsedAt: string | null;
  revokedAt: string | null;
  revokedBy: string | null;
  createdAt: string;
  createdBy: ApiKeyCreator | null;
  companyId: string;
  companyName: string | null;
}

const apiKeyApi = {
  list: (companyId: string): Promise<AxiosResponse<AdminApiKey[]>> =>
    agent.get("/admin/api-keys", { params: { companyId } }),

  revoke: (id: string): Promise<AxiosResponse<AdminApiKey>> => agent.delete(`/admin/api-keys/${id}`),
};

export default apiKeyApi;
